/* Livacils — page Activer mon bon cadeau
 * - Validates code pattern (trust-based, no API check)
 * - Unlocks the prestation cards with smooth animation
 * - Stores code in sessionStorage + appends to Cal.com URLs as numero-commande query param
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'livacils.giftcard.code';

  function track(name, extra) {
    var payload = Object.assign({ page_location: location.href }, extra || {});
    try { if (window.gtag) gtag('event', name, payload); } catch (e) {}
    try { if (window.fbq) fbq('trackCustom', name, payload); } catch (e) {}
  }

  function normalizeCode(raw) {
    if (!raw) return '';
    var c = String(raw).trim().toUpperCase();
    // Accept formats : #LIV1234, LIV1234, 1234, with or without leading #
    if (c.charAt(0) !== '#') c = '#' + c.replace(/^#+/, '');
    return c;
  }

  function isValidCode(code) {
    // Pattern : starts with # followed by 3-15 alphanumeric chars.
    // Trust-based — verification réelle se fait au Studio par Mélanie.
    return /^#[A-Z0-9-]{3,15}$/.test(code);
  }

  function unlock(section, code) {
    section.classList.add('is-unlocked');
    section.dataset.code = code;
    // Append code as query param to Cal.com booking links
    section.querySelectorAll('a[data-cal-slug]').forEach(function (a) {
      var url = new URL(a.getAttribute('href'), location.origin);
      url.searchParams.set('numero-commande', code);
      a.setAttribute('href', url.toString());
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('[data-redeem]');
    if (!section) return;

    var form = section.querySelector('[data-redeem-form]');
    var input = section.querySelector('[data-redeem-input]');
    var errorEl = section.querySelector('[data-redeem-error]');
    var successEl = section.querySelector('[data-redeem-success]');
    if (!form || !input) return;

    // Auto-unlock if code already stored this session
    var stored = '';
    try { stored = sessionStorage.getItem(STORAGE_KEY) || ''; } catch (e) {}
    if (stored && isValidCode(stored)) {
      input.value = stored;
      unlock(section, stored);
      if (successEl) successEl.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = normalizeCode(input.value);
      if (errorEl) errorEl.hidden = true;
      if (successEl) successEl.hidden = true;

      if (!isValidCode(code)) {
        if (errorEl) errorEl.hidden = false;
        input.focus();
        track('giftcard_code_invalid', { raw: input.value });
        return;
      }

      input.value = code;
      unlock(section, code);
      if (successEl) successEl.hidden = false;
      try { sessionStorage.setItem(STORAGE_KEY, code); } catch (err) {}
      track('giftcard_code_unlock', { code: code });

      // Scroll to vault after a short beat
      var vault = section.querySelector('[data-redeem-vault]');
      if (vault) {
        setTimeout(function () {
          vault.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 250);
      }
    });

    // Allow Enter from input to submit (default form behavior, but ensure focus stays nice)
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        form.requestSubmit();
      }
    });
  });
})();
